import { Component, OnInit } from "@angular/core";
import { PaginatedContent } from "../../../../api/common.types";
import { AccountFilter, ActiveConversation } from "../../home-admin-data/account.types";
import { take } from "rxjs";
import { UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { AccountService } from "../../home-admin-data/account.service";
import { NzTableQueryParams } from "ng-zorro-antd/table";
import { AccountType } from "../../../login-page/login-page-data/login.types";
import { FilterStorageService } from "../../../../api/filter-storage/filter-storage.service";
import { FiltersPage } from "../../../../api/filter-storage/filter-storage.types";
import { TableStateManager } from "../../utils/table-state-manager";

const FILTERS_PAGE = FiltersPage.ACTIVE_CONVERSATIONS;

@Component({
  selector: "mh-admin-communications",
  templateUrl: "./admin-communications.component.html",
  styleUrls: ["./admin-communications.component.less"],
})
export class AdminCommunicationsComponent implements OnInit {
  tableState = new TableStateManager<ActiveConversation>((filter) => this.accountService.loadActiveConversationsList(filter));
  searchForm!: UntypedFormGroup;

  constructor(
    private fb: UntypedFormBuilder,
    private accountService: AccountService,
    private filterStorageService: FilterStorageService,
  ) {}

  ngOnInit(): void {
    this.searchForm = this.fb.group({
      searchTerm: [null],
    });

    const storedFilters = this.filterStorageService.getStoredFilters()?.[FILTERS_PAGE];
    if (storedFilters) {
      this.searchForm.patchValue(storedFilters);
    }

    this.tableState.fetchData({...this.getDefaultQueryParams(), ...this.getFilterFormValues()});
  }

  onPageChange(pageIndex: number): void {
    this.tableState.onPageChange(pageIndex, () => this.getFilterFormValues());
  }

  onQueryParamsChange(params: NzTableQueryParams): void {
    this.tableState.onQueryParamsChange(params, () => this.getFilterFormValues());
  }

  submitFilterForm(): void {
    this.filterStorageService.saveFilters(this.searchForm, FILTERS_PAGE);
    this.tableState.onQueryChange({
      paging: {
        page: 1,
        itemsOnPage: this.tableState.data?.paging?.itemsOnPage || 0,
      },
      ...this.getFilterFormValues(),
    });
  }

  getFilterFormValues() {
    const searchField = this.getSearchField("searchTerm");

    return {
      searchTerm: searchField?.value || "",
    };
  }

  getSearchField(name: string) {
    return this.searchForm.get(name);
  }

  getDefaultQueryParams() {
    return {
      paging: {
        page: 1,
        itemsOnPage: 50,
      },
      searchTerm: '',
    };
  }

  protected readonly AccountType = AccountType;
}
